import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { raceTypesAPI } from '@/services/raceTypesApi';
import { queryKeys } from './queryKeys';

export function useRaceTypes(raceId?: any) {
  return useQuery({
    queryKey: queryKeys.races.types(raceId),
    queryFn: () => raceTypesAPI.getRaceTypes(raceId),
    enabled: !!raceId,
  });
}

export function useCreateRaceType(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => raceTypesAPI.createRaceType(raceId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.races.types(raceId) }),
  });
}

export function useUpdateRaceType(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => raceTypesAPI.updateRaceType(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.races.types(raceId) }),
  });
}

export function useDeleteRaceType(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => raceTypesAPI.deleteRaceType(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.races.types(raceId) }),
  });
}
